export enum BrandName {
  BAGY = 'bagy',
  CPLUG = 'cplug',
  TRAY = 'tray'
}

export interface BrandConfig {
  primaryColor: string
}
